import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <p>{`Hey guys, I'm Matthew! My pronouns are he/him. Some of my favorite hobbies are reviewing music (duh), playing video games (currently playing a lot of Fall Guys, which I suck at), speedcubing (I'm sub-10 on 3x3, and here's my `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=Gio-ATwqN5k"
      }}>{`best average on camera`}</a>{`), and following news and politics, especially in the US (please make it stop). My favorite artist is Porter Robinson. I am a member of the Nuraphone master race (they're seriously good headphones, get them if you're looking for nice cans) and the Yang Gang (he should've won). My 2 favorite albums of all time are Porter Robinson's `}<em parentName="p">{`Worlds`}</em>{` and Kero Kero Bonito's `}<em parentName="p">{`Time 'n' Place`}</em>{`, and I'm always on the lookout for good new music!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      